<template>
  <v-card class="reconciliation-card">
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('r-text-30') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="progress >= 4 ? cancelDialog = true : $emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="progress >= 4 ? cancelDialog = true : $emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-stepper v-model="progress">
      <v-stepper-items>
        <v-stepper-content class="pt-0" step="1">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center">
                <v-col cols="12">
                  <h2 class="mt-0 font-weight-medium text-center" :class="{'text-h1': $vuetify.breakpoint.mdAndUp, 'text-h3': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-1') }}</h2>
                  <p class="text-center font-weight-medium color-new-dark-orange--text">{{ $t('r-text-2') }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h4 class="text-center ma-0" :class="{'text-h7': $vuetify.breakpoint.mdAndUp, 'text-h8': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-3') }}</h4>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="startSelection">
                    <v-radio value="0" color="color-new-link-blue" class="mb-3" on-icon="far fa-check-square" off-icon="far fa-square" style="align-items: flex-start;">
                      <template v-slot:label>
                        <div>
                          <p class="ok-title xl bold color-new-link-blue--text mb-3">{{ $t('r-text-4') }}</p>
                          <p>{{ $t('r-text-5') }} <b>{{ordersOpenAmount | currency}}</b> {{ $t('r-text-6') }}</p>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio value="1" color="color-new-link-blue" on-icon="far fa-check-square" off-icon="far fa-square" style="align-items: flex-start;">
                      <template v-slot:label>
                        <div>
                          <p class="ok-title xl bold color-new-link-blue--text mb-3">{{ $t('r-text-7') }}</p>
                          <p>{{ $t('r-text-8') }}</p>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn tile large @click="startReconciliation" color="primary" class="wide-button" :loading="loading" :disabled="startSelection === null">
                    {{ $t('continue') }}
                  </v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content class="pt-0" step="2">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center">
                <v-col cols="12">
                  <h2 class="mt-0 font-weight-medium text-center" :class="{'text-h1': $vuetify.breakpoint.mdAndUp, 'text-h3': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-9') }}</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p>{{ $t('r-text-10') }}</p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn tile large @click="progress = 3; $matomo.trackEvent('Action', 'Make Settlement', 'Settlement Confirm')" color="primary" class="wide-button">{{ $t('r-text-10-1') }}</v-btn>
                </div>
                <div class="pa-3">
                  <v-btn tile outlined large color="color-new-link-blue" @click="progress = 1" class="wide-button">{{ $t('back') }}</v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content class="pt-0" step="3">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center">
                <v-col cols="12">
                  <h2 class="mt-0 font-weight-medium text-center" :class="{'text-h1': $vuetify.breakpoint.mdAndUp, 'text-h3': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-11') }}</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <div class="round color-project-1 white--text font-weight-medium">
                    <span>1</span>
                  </div>
                </v-col>
                <v-col cols="10" md="10">
                  <h4 class="mt-0" :class="{'text-h7': $vuetify.breakpoint.mdAndUp, 'text-h8': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-12') }}</h4>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <div class="round color-project-1 white--text font-weight-medium">
                    <span>2</span>
                  </div>
                </v-col>
                <v-col cols="10" md="10">
                  <h4 class="mt-0" :class="{'text-h7': $vuetify.breakpoint.mdAndUp, 'text-h8': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-13') }}</h4>
                  <p>{{ $t('r-text-15') }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <div class="round color-project-1 white--text font-weight-medium">
                    <span>3</span>
                  </div>
                </v-col>
                <v-col cols="10" md="10">
                  <h4 class="mt-0" :class="{'text-h7': $vuetify.breakpoint.mdAndUp, 'text-h8': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-16') }}</h4>
                  <p v-html="$t('r-text-17')"/>
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn tile large @click="startProcess" color="primary" class="wide-button">{{ $t('r-text-18') }}</v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content class="pt-0" step="4">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center">
                <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
                  <h2 class="mt-0 mb-3 font-weight-medium text-center" :class="{'text-h1': $vuetify.breakpoint.mdAndUp, 'text-h3': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-30') }}</h2>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row justify="center" v-if="orders.length > 0">
                    <div class="pa-3" v-if="orders.length === 1">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtNr') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small" data-matomo-mask>{{orders[0].orderNr}}</span>
                    </div>
                    <div class="pa-3" v-if="orders.length > 1">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtNrs') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small" data-matomo-mask>{{orderNrs}}</span>
                    </div>
                    <div class="pa-3">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('creditor') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small">{{orders[0].creditor.name}}</span>
                    </div>
                    <div class="pa-3" v-if="$vuetify.breakpoint.mdAndUp">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtOpenAmount') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small">{{ordersOpenAmount | currency}}</span>
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-stepper-header>
                    <v-stepper-step class="v-stepper__step--active" :complete="false" step="1" />
                    <v-divider></v-divider>
                    <v-stepper-step :complete="false" step="2" />
                    <v-divider></v-divider>
                    <v-stepper-step :complete="false" step="3" />
                  </v-stepper-header>
                </v-col>
                <v-col cols="12">
                  <h3 class="mt-3 text-center" :class="{'text-h3': $vuetify.breakpoint.mdAndUp, 'text-h7': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-19') }}</h3>
                  <p class="mb-0">{{ $t('r-text-20') }}</p>
                </v-col>
                <v-col cols="12" class="text-center" v-if="installments.length === 0">
                  <v-progress-circular :size="100" color="primary" indeterminate />
                  <p class="ok-title big mt-6 text-none">{{ $t('r-text-46') }}</p>
                </v-col>
                <v-col cols="12" class="text-center" v-if="installments.length > 0">
                  <h5 class="text-h8 mt-0 text-center">{{ $t('r-text-21') }}</h5>
                  <v-btn class="report-button" text @click="getReconciliationDocument" :disabled="loading" :loading="loading">
                    <v-icon class="mr-4">
                      far fa-file-pdf
                    </v-icon>
                    <span class="color-new-link-blue--text">{{ $t('r-text-22') }}</span>
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="installments.length > 0">
                  <h5 class="text-h8 mt-3 text-center">{{ $t('r-text-23') }}</h5>
                  <v-row justify="center">
                    <div class="pa-3 text-center">
                      <p class="ok-title">{{ $t('r-text-39') }}</p>
                      <p class="ok-subtitle"><span>{{ Math.ceil(installments[0].amount) | currency }} ({{ $t('r-text-28') }})</span></p>
                    </div>
                    <div class="pa-3 text-center">
                      <p class="ok-title">{{ $t('r-text-40') }}</p>
                      <p class="ok-subtitle"><span>{{ Math.ceil(installments[1].amount) | currency }}</span></p>
                    </div>
                    <div class="pa-3 text-center">
                      <p class="ok-title">{{ $t('r-text-41') }}</p>
                      <p class="ok-subtitle">{{ installments.length }} {{ $t('kpl') }}</p>
                    </div>
                    <div class="pa-3 text-center">
                      <p class="ok-title">{{ $t('r-text-42') }}</p>
                      <p class="ok-subtitle">{{ installments[installments.length - 1].dueDate | formatDate }}</p>
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="installments.length > 0">
                  <p class="pb-0">{{ $t('r-text-29') }}</p>
                </v-col>
                <v-col cols="12" v-if="installments.length > 0">
                  <v-divider />
                  <v-expansion-panels flat>
                    <v-expansion-panel v-if="installments.length > 0">
                      <v-expansion-panel-header class="pp-expansion-header py-6 text-center" expand-icon="fas fa-chevron-circle-down">
                        <span class="ok-title big color-new-link-blue--text mb-0">{{ $t('r-text-24') }}</span>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-data-table :headers="headers"
                                      :items="installments"
                                      hide-default-footer
                                      :items-per-page="-1"
                                      :mobile-breakpoint="0">
                          <template #item.sequence="{ item }">
                            <v-badge color="white">
                              <span slot="badge" class="black--text">{{ item.sequence }}</span>
                            </v-badge>
                          </template>
                          <template #item.duedate="{ item }">
                            {{ item.dueDate | formatDate }}
                          </template>
                          <template #item.amount="{ item }">
                            {{ item.amount | currency }}
                          </template>
                          <template #item.capital="{ item }">
                            {{ item.capital | currency }}
                          </template>
                          <template #item.costs="{ item }">
                            {{ item.costs | currency }}
                          </template>
                          <template #item.interest="{ item }">
                            {{ item.interest | currency }}
                          </template>
                        </v-data-table>
                        <v-row no-gutters justify="center">
                          <div class="pa-3">
                            <span class="ok-title small mr-2">{{ $t('capital') }}:</span>
                            <span class="text-caption">{{ calculatedPaymentPlan.totalCapital | currency }}</span>
                          </div>
                          <div class="pa-3">
                            <span class="ok-title small mr-2">{{ $t('interests') }}:</span>
                            <span class="text-caption">{{ calculatedPaymentPlan.totalInterest | currency }}</span>
                          </div>
                          <div class="pa-3">
                            <span class="ok-title small mr-2">{{ $t('r-text-25') }}:</span>
                            <span class="text-caption">{{ calculatedPaymentPlan.totalCost | currency }}</span>
                          </div>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-divider />
                </v-col>
                <div class="pa-3" v-if="installments.length > 0">
                  <v-checkbox color="color-new-title-grey" :disabled="installments.length === 0" v-model="agreed">
                    <div slot="label">
                      <span class="color-new-body-grey--text font-weight-bold">{{ $t('r-text-26') }}</span>
                    </div>
                  </v-checkbox>
                </div>
              </v-row>
              <v-row justify="center" align="center" v-if="installments.length > 0">
                <div class="pa-3">
                  <v-btn color="primary"
                         tile
                         :disabled="!agreed || loading"
                         :loading="loading"
                         @click="signReconciliation">
                    {{ $t('r-text-27') }}
                  </v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content class="pt-0" step="5">
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center">
                <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
                  <h2 class="mt-0 mb-3 font-weight-medium text-center" :class="{'text-h1': $vuetify.breakpoint.mdAndUp, 'text-h3': $vuetify.breakpoint.smAndDown }">{{ $t('r-text-30') }}</h2>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row justify="center" v-if="orders.length > 0">
                    <div class="pa-3" v-if="orders.length === 1">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtNr') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small" data-matomo-mask>{{orders[0].orderNr}}</span>
                    </div>
                    <div class="pa-3" v-if="orders.length > 1">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtNrs') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small">{{orderNrs}}</span>
                    </div>
                    <div class="pa-3">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('creditor') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small">{{orders[0].creditor.name}}</span>
                    </div>
                    <div class="pa-3">
                      <span :class="{'ok-title big mr-3': $vuetify.breakpoint.mdAndUp, 'ok-title small': $vuetify.breakpoint.smAndDown }">{{ $t('debtOpenAmount') }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown" />
                      <span class="ok-subtitle small">{{ordersOpenAmount | currency}}</span>
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-stepper-header>
                    <v-stepper-step :complete="true" step="1" />
                    <v-divider></v-divider>
                    <v-stepper-step class="v-stepper__step--active" :complete="false" step="2" />
                    <v-divider></v-divider>
                    <v-stepper-step :complete="false" step="3" />
                  </v-stepper-header>
                </v-col>
                <template v-if="paymentPending">
                  <v-row justify="center">
                    <v-col cols="12">
                      <h3 class="text-h3 mt-0 mb-3 text-center">{{ $t('r-text-36') }}</h3>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <v-progress-circular class="mb-3" :size="75" color="primary" indeterminate />
                      <p class="ok-title big mt-6 text-none">{{ $t('r-text-37') }}</p>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-col cols="12">
                    <h3 class="text-h3 mt-0 mb-6 text-center">{{ $t('r-text-31') }}</h3>
                    <p>{{ $t('r-text-32') }}</p>
                    <p class="mb-0">{{ $t('r-text-33') }}</p>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-center mb-3">
                      <p class="ok-subtitle big mb-0" v-if="paymentPlan !== null">{{ Math.ceil(paymentPlan.installments[0].eur) | currency }}</p>
                      <p class="ok-title big">{{ $t('r-text-34') }}</p>
                    </div>
                  </v-col>
                </template>
              </v-row>
              <v-row justify="center" v-if="!paymentPending">
                <div class="pa-3">
                  <v-btn color="primary" tile @click="setPaymentData(), recPaymentForm = true">{{ $t('r-text-35') }}</v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div class="payment-form">
      <shared-payment-forms :paymentData="paymentData" :cancellable="false" v-if="showPaymentForm" />
    </div>
    <v-dialog v-model="cancelDialog" width="640px" max-width="80%" ref="cDialog">
      <v-card>
        <v-card-text>
          <p class="text-center pt-6" v-html="$t('r-text-38')"></p>
          <v-row justify="center" align="center">
            <div class="pa-3">
              <v-btn color="primary" tile @click="cancelDialog = false">{{ $t('r-text-44') }}</v-btn>
            </div>
            <div class="pa-3">
              <v-btn text @click="cancelProcess">{{ $t('r-text-43') }}</v-btn>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['initialSubPoena'],
    data: function () {
      return {
        subpoena: null,
        progress: 0,
        startSelection: null,
        agreed: false,
        cancelDialog: false,
        calculatedPaymentPlan: null,
        paymentData: [],
        debtPaymentForm: false,
        recPaymentForm: false
      }
    },
    computed: {
      orders () {
        return this.subpoena !== null ? this.$store.getters.getDebts(this.subpoena.orderNrs) : []
      },
      ordersOpenAmount () {
        let amount = 0
        this.orders.forEach((order) => {
          amount += order.debtSummary.left
        })
        return amount
      },
      orderNrs () {
        return this.subpoena !== null ? this.subpoena.orderNrs.join(', ') : null
      },
      showReconciliationDialog () {
        return this.$store.getters.showReconciliationDialog
      },
      paymentPending () {
        return this.$store.getters.paymentPending
      },
      locale () {
        return this.$store.getters.locale
      },
      loading () {
        return this.$store.getters.loading
      },
      installments () {
        return this.calculatedPaymentPlan !== null ? this.calculatedPaymentPlan.paymentPlan.installments : []
      },
      headers () {
        return [
          { text: this.$t('installment'), value: 'sequence', sortable: false, class: 'pp-table-header' },
          { text: this.$t('dueDate'), value: 'duedate', sortable: false, class: 'pp-table-header' },
          { text: this.$t('installmentSequence'), value: 'amount', sortable: false, class: 'pp-table-header' },
          { text: this.$t('capital'), value: 'capital', sortable: false, class: 'pp-table-header' },
          { text: this.$t('costs'), value: 'costs', sortable: false, class: 'pp-table-header' },
          { text: this.$t('interests'), value: 'interest', sortable: false, class: 'pp-table-header' }
        ]
      },
      paymentPlan () {
        if (this.subpoena !== null && this.subpoena.status !== null && this.subpoena.status.msNr !== null) {
          return this.$store.getters.reconciliationPlan(parseInt(this.subpoena.status.msNr))
        } else {
          return null
        }
      },
      showPaymentForm () {
        return (this.recPaymentForm && this.progress === 5 && !this.paymentPending) || (this.debtPaymentForm && this.progress === 1 && this.startSelection === '0')
      }
    },
    mounted () {
      this.subpoena = this.initialSubPoena
      if (this.subpoena !== null && this.subpoena.status !== null) {
        this.$nextTick(function () {
          var status = this.subpoena.status
          if (status.paid !== null) {
            if (status.paymentNr !== null) {
              this.progress = 6
            } else {
              this.progress = 5
            }
          } else if (status.signed !== null) {
            this.progress = 5
          } else if (status.created !== null) {
            this.progress = 4
            console.log(this.$route.name)
            if (this.$route.name !== 'VerifyReconciliation') {
              this.calculatePaymentPlan()
            }
          }
        })
      } else {
        this.progress = 1
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      startReconciliation () {
        if (this.startSelection === '1') {
          this.progress = 2
          this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Choose Settlement")
        } else if (this.startSelection === '0') {
          this.debtPaymentForm = true
          this.$nextTick(function () {
            this.setDebtPaymentData()
          })
          this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Choose Payment")
        } else {
          this.close()
        }
      },
      cancelProcess () {
        var data = {
          SubPoenaNr: this.subpoena.nr,
          StatusNr: this.subpoena.status.nr,
          DebtNrs: this.subpoena.orderNrs
        }

        this.$store.dispatch('reconciliationCancel', data).then(subPoena => {
          this.progress = 1
          this.cancelDialog = false
          this.$refs.cDialog.removeOverlay
          this.subpoena = subPoena
          this.close()
        }, error => {
          console.log(error)
          this.progress = 1
          this.cancelDialog = false
          this.$refs.cDialog.removeOverlay
          this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
          this.close()
        })
      },
      startProcess () {
        this.progress = 4
        this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Start")

        var data = {
          SubPoenaNr: this.subpoena.nr,
          DebtNrs: this.subpoena.orderNrs
        }

        this.$store.dispatch('reconciliationStart', data).then(subPoena => {
          if (subPoena != null) {
            this.subpoena = subPoena
            this.calculatePaymentPlan()
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
          }
        }, error => {
          console.log(error)
          this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
        })
      },
      calculatePaymentPlan () {
        var data = {
          StatusNr: this.subpoena.status.nr,
          SubPoenaNr: this.subpoena.nr,
          DebtNrs: this.subpoena.orderNrs,
          Create: false
        }

        this.$store.dispatch('calculateReconciliationPaymentPlan', data).then(response => {
          if (response.status === 0) {
            this.calculatedPaymentPlan = response.responseObject
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
          }
        }, error => {
          console.log(error)
          this.$store.commit('setMessage', { type: 'error', text: 'Virhe', clickToDismiss: true })
        })
      },
      signReconciliation () {
        var data = {
          SubPoenaNr: this.subpoena.nr,
          StatusNr: this.subpoena.status.nr,
          Lang: this.$store.getters.longLocale
        }
        this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Sign Start")
        this.$store.dispatch('signReconciliation', data)
      },
      setDebtPaymentData () {
        let payments = []

        for (let i = 0; i < this.orders.length; i++) {
          let debt = this.orders[i]
          if (debt.debtSummary.left > 0) {
            payments.push({
              debtNr: debt.orderNr,
              description: debt.creditor.name,
              amount: debt.debtSummary.left,
              msnr: null
            })
          }
        }
        this.paymentData = payments
        setTimeout(() => {
          let el = this.$el.getElementsByClassName('payment-form')[0];
          if (el) {
            el.scrollIntoView({behavior: 'smooth'});
          }
        }, 100)
        this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment Full Settlement Start")
      },
      setPaymentData () {
        if (this.paymentPlan !== null) {
          this.paymentData = {
            debtNr: this.paymentPlan.debts[0].nr,
            description: null,
            amount: this.paymentPlan.nextInstallment.eur,
            msnr: this.paymentPlan.nr,
            paymentType: 'reconciliation'
          }
          setTimeout(() => {
            let el = this.$el.getElementsByClassName('payment-form')[0];
            if (el) {
              el.scrollIntoView({behavior: 'smooth'});
            }
          }, 100)
          this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Payment Start")
        } else {
          this.paymentData = null
        }
      },
      getReconciliationDocument () {
        var url = '/api/reconciliation/file/status/' + this.subpoena.status.nr + '/' + this.subpoena.nr
        this.$store.commit('setLoading', true)
        apiResource({ method: 'get', url: url, responseType: 'arraybuffer' }).then((response) => {
          this.$store.commit('setLoading', false)
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // IE10+ : (has Blob, but not a[download] or URL)
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, this.$t('r-text-45') + '.pdf')
          } else {
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = this.$t('r-text-45') + '.pdf'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch(() => {
          this.$store.commit('setLoading', false)
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "r-text-1": "Velkasi käsittely on edennyt käräjäoikeuteen",
  "r-text-2": "Jos et reagoi tilanteeseen nopeasti, seurauksena saattaa olla maksuhäiriömerkintä tai ulosottoon johtava menettely.",
  "r-text-3": "Voit välttää velkomustuomion kahdella tapaa:",
  "r-text-4": "Maksa velkasi kertamaksulla",
  "r-text-5": "Voit maksaa velkasumman",
  "r-text-6": "kertasuorituksena Oma B2 Impact -palvelun kautta.",
  "r-text-7": "Tee sovinto",
  "r-text-8": "Tekemällä sovintosopimuksen voit maksaa jäljellä olevan velan pois useammassa erässä. Sovinnon tekeminen edellyttää, että velkaan ei liity avointa reklamaatiota.",
  "r-text-9": "Tee sovinto",
  "r-text-10": "Sovinnon avulla voit maksaa avoimen velkasumman useammassa erässä. Sovinnon tekeminen edellyttää, että sitoudut maksusuunnitelmaan jonka käräjäoikeus lopulta vahvistaa sitovaksi.",
  "r-text-10-1": "Aloita",
  "r-text-11": "Näin teet sovinnon",
  "r-text-12": "Tutustu sopimukseen ja maksusuunnitelmaan",
  "r-text-13": "Hyväksy ja allekirjoita sovinto",
  "r-text-14": "Näin teet sovinnon",
  "r-text-15": "Sinun tulee vahvistaa sovintosopimus sekä siihen liittyvä maksusuunnitelma omilla verkkopankkitunnuksillasi.",
  "r-text-16": "Maksa suunnitelman ensimmäinen erä",
  "r-text-17": "<b>Sinun tulee maksaa ensimmäinen maksusuunnitelman erä Oma B2 Impact -palvelun kautta heti allekirjoituksen jälkeen</b> jotta B2 Impact voi hyväksyä sovinnon. Erän voi maksaa myös joku muu henkilö (esimerkiksi omainen tai edunvalvoja).",
  "r-text-18": "Aloita sovinnon tekeminen",
  "r-text-19": "Hyväksy sopimus ja maksusuunnitelma",
  "r-text-20": "Sovintoa varten sinun tulee ensimmäiseksi hyväksyä sovintosopimus ja siihen liittyvä maksusuunnitelma. Hyväksyntä tapahtuu sähköisellä allekirjoituksella, joka sinun tulee tehdä omilla pankkitunnuksillasi.",
  "r-text-21": "Tutustu sovintosopimukseen:",
  "r-text-22": "Avaa sovintosopimus (pdf)",
  "r-text-23": "Maksusuunnitelman tiedot:",
  "r-text-24": "Näytä maksusuunnitelman tiedot",
  "r-text-25": "Kulut yhteensä",
  "r-text-26": "Hyväksyn sovintosopimuksen ja maksusuunnitelman",
  "r-text-27": "Allekirjoita sopimus",
  "r-text-28": "maksettava heti",
  "r-text-29": "Maksusuunnitelman aikataulu on sitova, eikä maksueriä voi muokata jälkeenpäin. Ensimmäinen erä tulee maksaa heti allekirjoituksen jälkeen.",
  "r-text-30": "Sovinto",
  "r-text-31": "Maksa ensimmäinen erä",
  "r-text-32": "Kiitos! Olet nyt allekirjoittanut sovintosopimuksen. Ennen kuin sovintosopimus voidaan vahvistaa, sinun tulee maksaa maksusuunnitelman ensimmäinen erä.",
  "r-text-33": "Maksu tehdään Oma B2 Impact -palvelun kautta. Maksajana voi olla myös joku muu henkilö kuin alkuperäinen velallinen (esimerkiksi omainen tai edunvalvoja).",
  "r-text-34": "Sovinnon ensimmäinen erä",
  "r-text-35": "Siirry maksamaan",
  "r-text-36": "Maksua käsitellään, pieni hetki",
  "r-text-37": "Odotamme vahvistusta tehdystä suorituksesta",
  "r-text-38": "<b>Huom!</b> Sovintosopimuksesi ei ole vielä valmis. Viimeistele sopimus.",
  "r-text-39": "Ensimmäinen erä",
  "r-text-40": "Seuraavat erät",
  "r-text-41": "Erien lukumäärä",
  "r-text-42": "Viimeinen eräpäivä",
  "r-text-43": "Peruuta sovinto",
  "r-text-44": "Jatka sovinnon tekemistä",
  "r-text-45": "Sovintosopimus",
  "r-text-46": "pieni hetki, valmistelemme maksusuunnitelmaa"
  },
  "se": {
  "r-text-1": "Din fordran har överförts till tingsrätten",
  "r-text-2": "Genom att reagera snabbt kan du undvika betalningsanmärkning och utmätningsförfarande.",
  "r-text-3": "Det finns två sätt att undvika detta:",
  "r-text-4": "Du kan betala fordran i sin helhet ",
  "r-text-5": "Du kan göra en delbetalning på",
  "r-text-6": "via Min B2 Impact -tjänsten.",
  "r-text-7": "Gör ett förlikningsavtal",
  "r-text-8": "Genom att göra ett förlikningsavtal kan du betala din fordran i mindre delar. Ett förlikningsavtal kan inte göras ifall det finns en öppen reklamation i ärendet.",
  "r-text-9": "Gör ett förlikningsavtal",
  "r-text-10": "Med hjälp av ett förlikningsavtal kan du betala skulden i mindre delar. Då du gör ett förlikningsavtal, förbinder du dig till en överenskommen betalningsplan som stadfästs av tingsrätten.",
  "r-text-10-1": "Påbörja",
  "r-text-11": "Så här gör du ett förlikningsavtal",
  "r-text-12": "Bekanta dig med avtalet och betalningsplanen",
  "r-text-13": "Godkänn och underteckna förlikningsavtalet",
  "r-text-14": "Så här gör du ett förlikningsavtal",
  "r-text-15": "Förlikningsavtalet och dess betalningsplan måste undertecknas med dina egna nätbankskoder.",
  "r-text-16": "Betala första raten av betalningsplanen",
  "r-text-17": "<b>För att B2 Impact skall kunna godkänna förlikningsavtalet måste första raten av betalningsplanen betalas via Min B2 Impact-tjänsten genast efter att du undertecknat förlikningsavtalet.</b> Raten kan även betalas av en tredje person (t.ex. en närstående eller en god man).",
  "r-text-18": "Försätt skapa förlikningsavtalet",
  "r-text-19": "Godkänn avtalet och betalningsplanen",
  "r-text-20": "För att göra ett förlikningsavtal så godkänner du först förlikningsavtalet och dess betalningsplan. Godkännandet görs med en elektronisk underskrift med hjälp av dina egna nätbankskoder.",
  "r-text-21": "Bekanta dig med förlikningsavtalet:",
  "r-text-22": "Öppna förlikningsavtalet (pdf)",
  "r-text-23": "Betalningsplanens uppgifter:",
  "r-text-24": "Visa betalningsplanen",
  "r-text-25": "Kostnader totalt",
  "r-text-26": "Jag godkänner förlikningsavtalet och betalningsplanen",
  "r-text-27": "Underteckna avtalet",
  "r-text-28": "betalas genast",
  "r-text-29": "Betalningsplanen är bindande och betalningsraterna kan inte ändras i efterhand. Första raten betalas genast efter att förlikningsavtalet undertecknats.",
  "r-text-30": "Förlikningsavtal",
  "r-text-31": "Betala första raten",
  "r-text-32": "Tack! Du ha nu undertecknat förlikningsavtalet. För att avtalet skall godkännas behöver du betala första raten av betalningsplanen.",
  "r-text-33": "Betalningen görs via Min B2 Impact -tjänsten. Betalaren behöver inte vara samma person som gäldenären (kan t.ex. vara en närstående eller en god man)",
  "r-text-34": "Förlikningsavtalets första rat",
  "r-text-35": "Fortsätt till betalning",
  "r-text-36": "Betalningen behandlas, ett ögonblick",
  "r-text-37": "Vi väntar på att få betalningen bekräftad",
  "r-text-38": "<b>OBS!</b> Ditt förlikningsavtal är ännu inte färdigt. Slutför avtalet.",
  "r-text-39": "Första raten",
  "r-text-40": "Följande rater",
  "r-text-41": "Antal rater",
  "r-text-42": "Sista förfallodagen",
  "r-text-43": "Annulera förlikningen",
  "r-text-44": "Gör förlikningen färdig",
  "r-text-45": "Förlikningsavtalet",
  "r-text-46": "vänta, vi förbereder en betalningsplan"
  },
  "en": {
  "r-text-1": "Your case has progressed to the District Court",
  "r-text-2": "If you do not react quickly, the result may be a payment default entry or a transfer to enforcement.",
  "r-text-3": "You have two options to avoid these outcomes:",
  "r-text-4": "Payment in full",
  "r-text-5": "Pay the remaining amount of debt",
  "r-text-6": "in a single installment",
  "r-text-7": "Make a settlement",
  "r-text-8": "By making a settlement, it is possible for you to pay the outstanding amount of debt in several instalments. Making a settlement requires that your case has no outstanding complaints.",
  "r-text-9": "Make a settlement",
  "r-text-10": "By making a settlement, it is possible for you to pay the outstanding amount of debt in several instalments. Making a settlement requires that you commit to a pre-agreed payment plan that is confirmed as binding by the District Court. ",
  "r-text-10-1": "Begin",
  "r-text-11": "How to make a settlement",
  "r-text-12": "Familiarise yourself with the agreement and the payment plan",
  "r-text-13": "Accept and sign the settlement",
  "r-text-14": "How to make a settlement",
  "r-text-15": "The settlement agreement and the related payment plan must be signed  with your online banking credentials.",
  "r-text-16": "Pay the first installment",
  "r-text-17": "<b>The first installment must be paid via My B2 Impact service right after you have signed the agreement</b> in order for B2 Impact to be able to accept the settlement. The payment can also be made by another person (for example your next of kin or a trustee).",
  "r-text-18": "Continue",
  "r-text-19": "Sign the agreement and payment plan",
  "r-text-20": "To make a settlement you must first accept the the agreement and related payment plan. This is done with an electronic signature, which you can provide with your online banking credentials.",
  "r-text-21": "Review the settlement agreement:",
  "r-text-22": "View the agreement (pdf)",
  "r-text-23": "Payment plan details:",
  "r-text-24": "View payment plan details",
  "r-text-25": "Total costs",
  "r-text-26": "I accept the settlement agreement and the payment plan",
  "r-text-27": "Sign the agreement",
  "r-text-28": "paid immediately",
  "r-text-29": "The payment plan is binding, and cannot be altered afterwards. The first installment must be paid immediately.",
  "r-text-30": "Settlement",
  "r-text-31": "Pay the first installment",
  "r-text-32": "Thank you! You have now signed the agreement. Before we can confirm the settlement, you must pay the first installment of the payment plan.",
  "r-text-33": "The payment is made via My B2 Impact service. The payment can also be made by another person (for example your next of kin or a trustee).",
  "r-text-34": "First installment",
  "r-text-35": "Proceed to payment",
  "r-text-36": "Processing the payment, just a moment",
  "r-text-37": "Waiting for the transaction to be confirmed",
  "r-text-38": "<b>Please note!</b> Your settlement agreement is not yet ready. Finish the agreement.",
  "r-text-39": "First instalment",
  "r-text-40": "Following instalments",
  "r-text-41": "Number of instalments",
  "r-text-42": "Final instalment",
  "r-text-43": "Cancel the agreement",
  "r-text-44": "Continue making the agreement",
  "r-text-45": "Settlement",
  "r-text-46": "please wait, we are preparing the payment plan"
  }
  }
</i18n>

<style>
  .reconciliation-card .v-stepper, .reconciliation-card .v-stepper__header {
    box-shadow: none;
  }
  .v-stepper__step--active:not(.v-stepper__step--complete) > span.v-stepper__step__step {
    background: #3eb1c8 !important;
  }
</style>
